// AccountInfo.js
import React from "react";
export default function AccountInfo({ user, onUpdate }) {
  return (
    <div className="space-y-5">
      <h2 className="text-3xl">Contact Information</h2>
      <div className="panel p-5 space-y-4">
        <div>
          <p className="text-xs tracking-[0.12em] uppercase text-[var(--muted)]">Name</p>
          <p className="text-lg">{user?.full_name || "Unknown"}</p>
        </div>
        <div>
          <p className="text-xs tracking-[0.12em] uppercase text-[var(--muted)]">Email</p>
          <p className="text-lg">{user?.email || "Unknown"}</p>
        </div>
      </div>
      <button className="btn-outline px-5 py-2.5" onClick={onUpdate}>Refresh</button>
    </div>
  );
}
